import { useRedux } from "hooks";
import React, { forwardRef, useCallback, useEffect, useRef, useState } from "react";
import { createSelector } from "reselect";
import WorkplaceHead from "./WorkplaceHead";
import WorkplaceInput from "./WorkplaceInput";
import AppSimpleBar from "components/AppSimpleBar";
import WorkplaceQuill from "components/WorkplaceQuill";
import { LogDb, Utils } from "helpers/utils";
import Loader from "components/Loader";
import { WpConver, WpEmoji, WpPostType, WpSliceData, WpStatus } from "../../../redux/workplace/wpTypes";
import { togglePostEmoji, setSnooze } from "../../../redux/workplace/wpActions";
import classnames from "classnames";
import UserAvatar from "components/UserAvatar";
import { updateReadApi } from "../../../api/wpapi";
import { APIClient } from "../../../api/apiCore";
import * as urls from "../../../api/urls";


import { Const } from "const";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import DatePicker from "react-datepicker";
import LoadingIconWithText from "components/LoadingIconWithText";
import WorkplaceCollectionModal from "./WorkplaceCollectionModal";
import { useNavigate } from "react-router-dom";
import { DbUtils } from "helpers/dbUtils";

interface WorkplaceContentProps {

}
const WorkplaceContent = ({ }: WorkplaceContentProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (state: any) => state.Profile2,
    (state: any) => state.Layout,
    (wp: WpSliceData, p2, layout) => ({
      activePostId: wp.activePostInfo.postId,
      activePostStatus: wp.activePostInfo.status,
      activePostStatusById: wp.activePostInfo.statusById,
      activePostStatusDate: wp.activePostInfo.statusDate,
      activePostStatusRemark: wp.activePostInfo.statusRemark,
      activePostStatusByName: wp.activePostInfo.statusByName,
      activePostYouIsMember: wp.activePostInfo.youIsMember || wp.activePostInfo.isYourPost,
      converLoading: wp.converLoading,
      converErrMsg: wp.converErrMsg,
      convers: wp.convers,
      curUserId: p2.userId,
      layoutMode: layout.layoutMode,
      postTitles: wp.titles
    })
  );
  // Inside your component
  const {
    activePostId, converLoading, converErrMsg, convers, curUserId
    , activePostStatus, activePostStatusDate, activePostStatusRemark, activePostStatusByName
    , activePostYouIsMember
    , layoutMode
    , postTitles

  } = useAppSelector(storeData);

  const isDarkMode = layoutMode === "dark";
  const activePostIdRef = useRef(activePostId);
  useEffect(() => { activePostIdRef.current = activePostId }, [activePostId]);

  useEffect(() => {
    // console.log('activePostYouIsMember = ' + activePostYouIsMember);
  }, [activePostYouIsMember]);

  const INPUT_SMALL_HEIGHT = 160;
  const INPUT_TOOLBAR_HEIGHT = 90;
  const INPUT_LARGE_HEIGHT = 600;

  const [inputPanelHeight, setInputPanelHeight] = useState<number>(INPUT_SMALL_HEIGHT);
  const [inputEditorHeight, setInputEditorHeight] = useState<number>(INPUT_SMALL_HEIGHT - INPUT_TOOLBAR_HEIGHT);
  const [isLageEditor, setIsLageEditor] = useState<boolean>(false);
  const [isEmojiRespShow, setIsEmojiRespShow] = useState<boolean>(false);
  const [emojiRespPos, setEmojiRespPos] = useState<any>({ left: 0, top: 0 });
  const refScroll = useRef<any>();

  const emojis = [
    { name: 'OK', icon: '🆗' },
    { name: 'Smile', icon: '😊' },
    { name: 'Cry', icon: '😢' },
    { name: 'Crying Smile', icon: '😂' },

    { name: 'Good', icon: '👍' },
    { name: 'Thank you', icon: '🙏' },
    { name: 'Strong', icon: '💪' },
    { name: 'Crab', icon: '👏' },

    { name: 'Done', icon: '✅' },
    { name: 'No', icon: '❌' },
    { name: 'Smile Glasses', icon: '😎' },
    { name: 'Ok Hand', icon: '👌' },

    // { name: 'Plus 1', icon: '➕' },
    // { name: 'Minus 1', icon: '➖' },

    { name: '100%', icon: '💯' },
    { name: 'Love', icon: '❤️' },
    // { name: 'Negative', icon: '🆖' }, //{ name: 'Wait', icon: '⌛' },
    { name: 'Delivery', icon: '🚚' },
    { name: 'Soon', icon: '🔜' },

  ];

  const onLargeStageClick = () => {
    setIsLageEditor((prev) => !prev);
  }
  useEffect(() => {
    const panelHeight = (isLageEditor ? INPUT_LARGE_HEIGHT : INPUT_SMALL_HEIGHT);
    setInputPanelHeight(panelHeight);
    setInputEditorHeight(panelHeight - INPUT_TOOLBAR_HEIGHT);
  }, [isLageEditor]);

  useEffect(() => {
    if (activePostId == "") { // new post
      setIsLageEditor(true);
    } else if (isLageEditor) {
      setIsLageEditor(false);
    }
  }, [activePostId]);

  // const [onSaving, setOnSaving] = useState<boolean>(false);
  // const onSave = async (text: string, html: string, blobUploads: QuillFileUpload[]) => {
  //   try {
  //     setOnSaving(true);
  //     console.log({ text, html, blobUploads });
  //     setOnSaving(false);
  //   } catch (e) {
  //     Utils.HandleException(e);
  //     setOnSaving(false);
  //   }
  // }
  const isForwarded = false;
  const isDark = Utils.IsDarkTheme();

  let newTab: Window | null = null;
  // Function to open a URL in a new tab and reuse the same tab for subsequent calls
  function openUrlInSameTab(url: string): void {
    const tabName = "myUniqueTabName"; // Unique name for the tab
    if (!newTab || newTab.closed) {
      // If the tab doesn't exist or is closed, open a new one
      newTab = window.open(url, tabName);
    } else {
      // If the tab is already open, update its location
      newTab.location.href = url;
      newTab.focus();
    }
  }

  useEffect(() => {
    // Function to handle click event
    const handleAClick = (event: Event) => {
      const target = event.target as HTMLElement;
      if (target.tagName === "A" || target.tagName === "IMG") {
        const atype = target.getAttribute("atype");
        // console.log('atype = ' + atype);
        if (atype === "image" || atype === "tag") {
          event.preventDefault(); // Prevent default navigation (if needed)
          if (atype === "image") {
            const img = target as HTMLImageElement

            /* 20250729 make it preview by prev/next
            //const url = img.src.replaceAll("thumb_/", "");
            // Remove 'thumb_/' from the URL
            let cleanedUrl = img.src.replace('thumb_/', '');

            // Insert 'https://domain2.com' before '/_uploadwp'
            const uploadIndex = cleanedUrl.indexOf('/_uploadwp');
            // console.log('uploadIndex = ' + uploadIndex);
            if (uploadIndex !== -1) {
              const prUrl = process.env.REACT_APP_URL_FOR_STATIC;
              if (prUrl) {
                cleanedUrl = prUrl + cleanedUrl.substring(uploadIndex);
              }
            }
            console.log('cleanedUrl:' + cleanedUrl);

            openUrlInSameTab(cleanedUrl);
            */
            onPreviewImage(img.id);
          } else if (atype === "tag") {
            const tagId = Utils.ToNumber(target.getAttribute("aval"), -1) ?? -1;
            onTagClick(tagId);
          } else {
            alert('Click ' + atype);
          }

          // console.log(`Clicked on a link with atype="${atype}"`);
          // Perform your logic here
        } else if (atype === "file") {
          const lnk = target as HTMLLinkElement;
          let href = lnk.href;
          new LogDb().Write(`Click tag file ${href}`);
          /*

          const lnk = target as HTMLLinkElement;
          let href = lnk.href;
          const uploadIndex = href.indexOf('/_uploadwp');
          if (uploadIndex !== -1) {
            event.preventDefault();
            const prUrl = process.env.REACT_APP_URL_FOR_STATIC;
            if (prUrl) {
              // console.log('href = ' + href);
              href = href.replace(window.location.origin, prUrl);
              // console.log('href = ' + href);
            }
            openUrlInSameTab(href);
          }

          */

        }

      }
    };

    // Attach event listener to the document (event delegation)
    document.addEventListener("click", handleAClick);

    // Cleanup event listener on unmount
    return () => {
      document.removeEventListener("click", handleAClick);
    };
  }, []);

  // const lastMessageRef = useRef<HTMLLIElement | null>(null);
  // const lastMessageRef = useRef<HTMLDivElement | null>(null);
  const [firstTimeScroll, setFirstTimeScroll] = useState<boolean>(true);
  const [lastConverCount, setLastConverCount] = useState<number>(0);
  const [haveNewText, setHaveNewText] = useState<string | null>(null);
  const firstUnreadIndex = (convers || []).findIndex((m: WpConver) => !m.isRead);
  useEffect(() => {
    const divConverContainer = document.getElementById('divConverContainer');
    const scrollToIndex = firstUnreadIndex >= 0 ? firstUnreadIndex : ((divConverContainer?.children?.length ?? 0) - 1);
    // console.log('scroll to index = ' + scrollToIndex + ' of total count = ' + (divConverContainer?.children?.length ?? 0));
    if (scrollToIndex >= 0) {
      const backButton = document.getElementById("back-button-wp") as HTMLButtonElement | null;
      let isUserReading = false;
      if (firstTimeScroll == false && backButton != null && backButton.classList.contains("show") && convers[convers.length - 1].postById != curUserId) {
        isUserReading = true;
      }
      // console.log({ firstTimeScroll, scrollToIndex, firstUnreadIndex, isUserReading });
      // console.log('convers.length = ' + convers.length, convers[0]);
      if (!isUserReading) {
        const listItem = divConverContainer?.children[scrollToIndex] as HTMLElement;
        const toBottom = scrollToIndex == ((divConverContainer?.children?.length ?? 0) - 1);
        // console.log(listItem);
        if (toBottom) {
          //refScroll.current.scrollTop = refScroll.current?.scrollHeight;
          // console.log('scroll to bottom');
          listItem?.scrollIntoView({ behavior: firstTimeScroll ? "instant" : "smooth", block: "start" });
        } else {
          listItem?.scrollIntoView({ behavior: firstTimeScroll ? "instant" : "smooth", block: "center" });
        }
        setLastConverCount(convers.length);
      } else { // user is reading
        if (lastConverCount != convers.length) { // have new text
          setHaveNewText(convers[convers.length - 1].postByName);
        }
      }
    }
    setFirstTimeScroll(false);
    showBackButton();
    let updateRead = firstUnreadIndex >= 0 && activePostId;
    if (!updateRead) {
      const selectedTitle = postTitles.filter(x => x.postId === activePostId);
      if (selectedTitle && selectedTitle.length > 0) updateRead = selectedTitle[0].unread > 0 ? "1" : null;
    }

    if (updateRead/*firstUnreadIndex >= 0 && activePostId*/) { // have unread item
      try {
        //console.log('update read on : ' + activePostId);
        fnUpdateUnread(activePostId ?? "");

        // const rs = updateReadApi(activePostId);
        // console.log('updateReadApi:', rs);
      } catch (e) {
        Utils.HandleException(e, false);
      }
    }
  }, [convers]);

  useEffect(() => {
    // 20250925 save in local
    try {
      if (activePostId != null && activePostId != "") {
        // console.log('save post conver to mem ' + activePostId, {convers});
        DbUtils.wp_load_post_conver(activePostId, convers);
      }
    } catch (e2) {
      Utils.HandleException(e2, false);
    }
  }, [activePostId, convers]);

  const fnUpdateUnread = async (postId: string) => {
    try {
      const rs = await updateReadApi(postId);
      const snooze = rs?.snooze ? true : false;
      dispatch(setSnooze(postId, snooze));
      // console.log('updateReadApi:', rs);
    } catch (e) {
      const msg = Utils.GetMessageFromExecption(e);
      console.error(msg);
      if (msg.includes("Object reference not set to an instance of an object")) {
        Utils.HandleException(e, false);
      } else {
        Utils.HandleException(e, true);
      }

    }
  }

  useEffect(() => {
    setFirstTimeScroll(true);
  }, [activePostId]);

  useEffect(() => {
    if (converLoading) {
      setFirstTimeScroll(true);
    }
  }, [converLoading]);

  interface ContentProps { conv: WpConver, index: number }

  // แสดง icon + ชื่อ + เวลา และแถวล่างเป็น content
  const ContentV1: React.FC<ContentProps> = ({ conv }) => {
    return (
      <>
        <div className="d-flex align-items-center mb-1 ms-1" style={{ position: "relative" }}>
          <div className={classnames("chat-user-img", "align-self-center", "me-2", "ms-0",)}>
            <UserAvatar profileImage={conv.pictureUrl ?? ""} bgColor={conv.bgColor ?? ""} foreColor={conv.foreColor ?? ""} abbrName={conv.abbrName ?? ""} size={"xs"} includeDivContainer={true} />
          </div>
          <div className="overflow-hidden">
            <p className="text-truncate mb-0">
              {conv.postByName}
            </p>
            <p className="text-truncate mb-0 last-chat-text" style={{ lineHeight: "13px" }}>
              {Utils.GetShortDateTimeToShowInChat(conv.postDateTime, true)}
            </p>
          </div>
          <div className="ms-auto text-end">
            ...
          </div>
          <i className="fas fa-sort-up icon-caret"></i>
        </div>
        <div className={classnames("wp-conver-content", { "mine": conv.isFromMe })} dangerouslySetInnerHTML={{ __html: conv.bodyHtml ?? "" }}>
        </div>
      </>
    );
  }

  const formatQuillContent = (content: string) => {
    return content.replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;'); // Replace tab with 4 spaces
  };

  const viewPostMember = async (postId: string) => {
    const api = new APIClient;
    api.fnPostForm(urls.WP_GET_POST_MEM_READ, { postId: postId })
      .then(rs => {
        var html = `<table width="100%" border="0">`;
        rs.forEach((mem: any) => {
          const iconClass = mem.isRead ? "text-primary" : "text-secondary";
          html += `<tr>`;
          html += `<td align="left">${mem.displayName2}</td>`;
          html += `<td align="left"><i class="fas fa-eye ${iconClass}"></i>&nbsp;${mem.isRead ? Utils.GetShortDateTimeToShowInChat(mem.readDateTime, false) : ""}</td>`;
          html += `</tr>`;
        });
        html += `</table>`;
        alert(html);
      })
      .catch(e => Utils.HandleException(e, true));
  }

  const onCopyPostConent = async (postId: string) => {
    try {
      const div = document.getElementById(`divWpContent-${postId}`);
      if (div) {
        const paragraphs = Array.from(div.querySelectorAll("p"));
        const lines = paragraphs.map(p => {
          const text = p.textContent?.trim();
          return text === "" ? "" : text; // Preserve empty <p> as blank line
        });

        // Combine all lines with single newlines — blank lines are preserved as empty strings
        const textToCopy = lines.join("\n");
        await navigator.clipboard.writeText(textToCopy);
      }
      console.log(postId);
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const [toolPostInfo, setToolPostInfo] = useState<any>({});

  const onShowRespEmojiPlate = (target: HTMLElement/*event: React.MouseEvent<HTMLElement>*/) => {
    triggerRef.current = target;// event.currentTarget;
    // Get the position of the clicked icon relative to the viewport
    const iconRect = target/*event.currentTarget*/.getBoundingClientRect();
    const containerRect = document.getElementById("workplace-container")?.getBoundingClientRect();
    if (!containerRect) return;

    const toolInfo = {
      postId: target.getAttribute('data-postid'),
      postIdParent: target.getAttribute('data-postidparent'),
      isFromMe: Utils.ToBool(target.getAttribute('data-isfromme'), false),
    };
    setToolPostInfo(toolInfo);

    // Calculate position relative to container, accounting for scroll
    // const scrollLeft = containerRef.current.scrollLeft;
    const scrollTop = (containerRect as any).scrollTop ?? 0;
    const scrollLeft = (containerRect as any).scrollLeft ?? 0;

    // Estimated popup size (or use a ref to measure if dynamic)
    const popupWidth = 150;
    const popupHeight = 190;

    // Available space around the icon
    const spaceBelow = window.innerHeight - iconRect.bottom;
    const spaceAbove = iconRect.top;
    const spaceRight = window.innerWidth - iconRect.right;
    const spaceLeft = iconRect.left;

    // Decide vertical position (top)
    let top;
    if (spaceBelow < popupHeight && spaceAbove >= popupHeight) {
      // Show above
      top = iconRect.top - containerRect.top + scrollTop - popupHeight;
    } else {
      // Show below
      top = iconRect.top - containerRect.top + scrollTop + iconRect.height;
    }

    // Decide horizontal position (left)
    let left;
    if (spaceRight < popupWidth && spaceLeft >= popupWidth) {
      // Show left-aligned if not enough space to the right
      left = iconRect.right - containerRect.left - popupWidth;
    } else {
      // Show right-aligned (default)
      left = iconRect.left - containerRect.left;
    }

    // console.log('top,lef:',{top, left, bottom:top+popup});

    setEmojiRespPos({
      top: top,
      left: left
    });

    // console.log('toggle emoji pane');
    setIsEmojiRespShow(true);//prev => !prev);
  }

  const popupRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!isEmojiRespShow) return;

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      const dataEmoji = (target as any).getAttribute('data-emoji');
      if (dataEmoji == "1") { // click on emoji icon
        onShowRespEmojiPlate(target as HTMLElement);//event as unknown as React.MouseEvent<HTMLElement>);
      } else {
        if (
          popupRef.current &&
          !popupRef.current.contains(target) &&
          triggerRef.current &&
          !triggerRef.current.contains(target)
        ) {
          console.log('hide emoji from click outside');
          setIsEmojiRespShow(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEmojiRespShow]);

  const test = async () => {
    dispatch(togglePostEmoji('588f80c4-2344-421f-8c0e-162b36de1f17', 'd4593435-36a7-4410-9f05-8dffc6a44d7f', 'Cry', '😢', false, 'กิติศักดิ์ แสงทอง'));
    dispatch(togglePostEmoji('588f80c4-2344-421f-8c0e-162b36de1f17', 'd4593435-36a7-4410-9f05-8dffc6a44d7f', 'No', '❌', true, 'กิติศักดิ์ แสงทอง'));
  }

  // แสดง icon ด้าย ซ้าย ชื่อ + เวลา และ content โดย content เยื้องมาจาก icon
  const ContentV2: React.FC<ContentProps> = ({ conv, index }) => {
    // console.log(conv.bodyHtml);
    return (
      <div key={index} className="mb-1 ms-1" style={{ display: "flex", alignItems: "flex-start" }}>
        <div className="" style={{ paddingTop: "5px" }} >
          <UserAvatar
            profileImage={conv.pictureUrl ?? ""}
            bgColor={conv.postById === Const.USER_ID_BOT ? "transparent" : (conv.bgColor ?? "")}
            foreColor={conv.postById === Const.USER_ID_BOT ? "red" : (conv.foreColor ?? "")}
            abbrName={conv.postById === Const.USER_ID_BOT ? "🔔" : (conv.abbrName ?? "")}
            size={"xs"}
            includeDivContainer={true}
          />
        </div>
        <div className="" style={{ display: "flex", flexDirection: "column", flex: "1" }}>
          {/* avatar */}
          <div className="">
            <p className={classnames("text-truncate mb-0", { "wp-from-me": conv.isFromMe, "text-danger": conv.postById === Const.USER_ID_BOT })}>
              {/* {index}. */}
              <span m-id={conv.postId} className={classnames({ "wp-unread": !conv.isRead })}>{conv.postByName}</span>
              &nbsp;-&nbsp;
              <span className={classnames("last-chat-text", { "text-danger": conv.postById === Const.USER_ID_BOT })}>{Utils.GetShortDateTimeToShowInChat(conv.postDateTime, false)}</span>
            </p>
          </div>

          <div className="wp-conver-content">

            {/* post content */}
            <div id={`divWpContent-${conv.postId}`} style={{ flex: "1" }} className={classnames({ "mine": conv.isFromMe })} dangerouslySetInnerHTML={{ __html: formatQuillContent(conv.bodyHtml ?? "") }}>

            </div>

            {/* post command */}
            <div className="wp-post-content-command" style={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-end' }}>
              <div>
                <div className="wp-post-resp-ctn" style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <i
                    className="fas fa-ellipsis-v hand text-gray mb-0 wp-post-menu-icon"
                    data-emoji="1"
                    data-postid={conv.postId}
                    data-postidparent={conv.postIdParent}
                    data-isfromme={conv.isFromMe}
                    onClick={(e) => onShowRespEmojiPlate(e.currentTarget)}
                  // style={{position:"absolute", left:"28px", width:"20px", textAlign:"center"}}
                  // onMouseOver={(e) => onShowRespEmojiPlate(e.currentTarget)}
                  >
                  </i>
                  {(conv.emojis ?? []).filter(e => e.mbr).map((em: WpEmoji, index2: number) => (
                    <span
                      key={conv.postId + em.nm + index2} className="wp-post-resp-emoji hand hover"
                      onClick={(e) => onClickRespEmojiToggle(conv.postId, conv.postIdParent, em.nm, em.ji)}
                    >{em.ji}{em.mbr.replaceAll(Const.EMOJI_MEMBER_SPLITTER, ", ")}</span>
                  ))}
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: "5px" }} >
                <i className="far fa-copy hand wp-eye-who-read mb-1" onClick={() => onCopyPostConent(conv.postId)} ></i>
                <i className="fas fa-eye hand wp-eye-who-read mb-1" onClick={() => viewPostMember(conv.postId)} ></i>
              </div>
            </div>
          </div>


        </div>
      </div >
    );
  }

  const ContentUnsend: React.FC<ContentProps> = ({ conv, index }) => {
    return (
      <div key={index} className="workplace-post-unsend" style={{ /*display: "flex", alignItems: "flex-start"*/ }}>
        -- {conv.postByName} ยกเลิกข้อความ --
      </div>
    )
  }

  const ContentChangeStatus: React.FC<ContentProps> = ({ conv, index }) => {
    const isClose = (Utils.ToNumber(conv.postTypeInfo, -1) == WpStatus.Close);
    return (
      <div key={index} className="workplace-post-status" style={{ /*display: "flex", alignItems: "flex-start"*/ }}>
        --&nbsp;
        {conv.postByName}
        {(isClose) && (<i className="fas fa-check-circle text-danger ms-2"></i>)}
        {(!isClose) && (<i className="fas fa-upload text-success ms-2"></i>)}
        &nbsp;
        <span className={classnames({ "text-danger": isClose, "text-blue": !isClose })}>
          {Utils.GetWpStatus(Utils.ToNumber(conv.postTypeInfo, WpStatus.Open) as WpStatus)}โพส
        </span>
        &nbsp;เมื่อ {Utils.GetDMYHHMM(conv.postDateTime)}
        &nbsp;--
        {conv.bodyHtml && (
          <>
            <br />เหตุผล: <span dangerouslySetInnerHTML={{ __html: conv.bodyHtml ?? "" }} className={isClose ? "text-danger" : "text-success"}></span>
          </>
        )}
      </div>
    )
  }


  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    //const target: any = event.target;
    showBackButton();
  };

  const showBackButton = async () => {
    try {
      const scrollableNode = refScroll.current?.getScrollElement();
      // console.log({ scrollHeight, scrollTop, clientHeight });
      const backButton = document.getElementById("back-button-wp") as HTMLButtonElement | null;
      if (backButton) {
        const isNotAtBottom = scrollableNode.scrollHeight - scrollableNode.scrollTop > scrollableNode.clientHeight + 1;
        if (isNotAtBottom) {
          backButton.classList.add("show");
        } else {
          backButton.classList.remove("show");
          setHaveNewText(null);
        }
      }
    } catch (e) {
      Utils.HandleException(e, false);
    }
  }

  const onGoBottom = async () => {
    try {
      // refScroll.current.scrollTop = refScroll.current?.scrollHeight;
      const scrollableNode = refScroll.current?.getScrollElement();
      scrollableNode.scrollTo({
        top: scrollableNode.scrollHeight,
        behavior: 'smooth'
      });
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onTagClick = async (tagId: number) => {
    try {
      const api = new APIClient();
      if (tagId == -1) {
        alert('Invalid tag id');
      } else {
        api.fnPostForm(urls.WP_LOAD_TAG_INFO, { tagId: tagId })
          .then(rs => {
            // console.log('tag info:', rs);
            if (rs.length > 0) {
              let ar: string[] = [];
              let title = '';
              rs.forEach((el: any, index: number) => {
                if (index == 0) {
                  title = `Tag <span class="text-primary">${el.catName} @${el.name}</span>`;
                  if (el.category == Const.WP_CAT_CUS) {
                    const erpUrl = Const.ERP_CUSTOMER_PAGE.replaceAll('[CustomerId]', el.tagKeyId);
                    title += `&nbsp;<a href="${erpUrl}" target="erp_cus_info_${el.tagKeyId}"><span class="badge badge-soft-primary rounded p-1 ml-1 bg-primary hand">ลูกค้ารายตัว</span></a>`;
                  }
                }
                if (el.memberCat) {
                  ar.push(`<tr><td>${el.memberCat}</td><td align="left"><i class="${el.memberIcon}"></i>&nbsp;${el.memberName}</td><td align="center">${el.memberRole}</td></tr>`);
                }
              });
              if (ar.length > 0) {
                alert(title + '<table width="100%">' + ar.join('') + '</table>');
              } else {
                alert(title + '<br/>ไม่มีสมาชิกใน tag');
              }

            } else {
              alert('Not found information of tag selected');
            }
          })
          .catch(e2 => Utils.HandleException(e2, true))
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onClickRespEmojiToggle = async (postId: string, postIdParent: string, emojiName: string, emojiSymbol: string) => {
    try {
      const api = new APIClient();
      const parm = {
        postId: postId,
        postIdParent: postIdParent,
        fromDeviceId: Utils.GetDeviceId(),
        emojiName: emojiName,
        emojiSymbol: emojiSymbol
      };
      setIsEmojiRespShow(false);
      api.fnPostForm(urls.WP_SET_RESP_EMOJI, parm)
        .then(rs => { })
        .catch(e2 => Utils.HandleException(e2, true));
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onClickRespEmoji = async (emoji: any) => {
    try {
      onClickRespEmojiToggle(toolPostInfo.postId, toolPostInfo.postIdParent, emoji.name, emoji.icon);
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const [unSendPostProcessing, setUnSendPostProcessing] = useState<boolean>(false);
  const onUnSendPost = async () => {
    try {
      setUnSendPostProcessing(true);
      const api = new APIClient();
      api.fnPostForm(urls.WP_UPDATE_UNSEND, {
        fromDeviceId: Utils.GetDeviceId(),
        postId: toolPostInfo.postId
      })
        .then(rs => {
          setIsEmojiRespShow(false);
          setUnSendPostProcessing(false);
        })
        .catch(e2 => { setIsEmojiRespShow(false); Utils.HandleException(e2, true); setUnSendPostProcessing(false); });

    } catch (e) {
      Utils.HandleException(e, true);
      setUnSendPostProcessing(false);
    }
  }

  useEffect(() => {
    // console.log('toolPostInfo:', toolPostInfo);
    if (isEmojiRespShow) {
      const mnuUnsendPost = document.getElementById('mnuUnsendPost');
      if (mnuUnsendPost) mnuUnsendPost.style.display = toolPostInfo.isFromMe ? "block" : "none";
    }
  }, [isEmojiRespShow, toolPostInfo]);

  const heightHeader = 70;
  //const heightBottom = activePostStatus === WpStatus.Open ? 140 : 0;
  const heightBottom = activePostStatus === WpStatus.Open ? 150 : 0; // 20270702 adjust little gap for able to display in mobile more clear


  const [snoozeDateTime, setSnoozeDateTime] = useState<any>(null);
  const snoozeRef = useRef<HTMLDivElement | null>(null);
  const [isSnoozeOpen, setIsSnoozeOpen] = useState<boolean>(false);
  const [isSnoozeLoading, setIsSnoozeLoading] = useState<boolean>(false);
  const [snoozeErr, setSnoozeErr] = useState<string>("");

  const onSnoozeClick = (sender: any, postId: string) => {
    const isOpen = !isSnoozeOpen;
    setIsSnoozeOpen(isOpen);
    if (isOpen) {
      setIsSnoozeLoading(true);
      const api = new APIClient();
      api.fnPostForm(urls.WP_POST_SNOOZE_LOAD, { postId: postId })
        .then(rs => {
          setIsSnoozeLoading(false);
          const date = new Date(rs.snoozeDateTime);
          console.log([date, rs.snoozeDateTime]);
          setSnoozeDateTime(date);
          console.log(rs);
        })
        .catch(err => {
          setIsSnoozeLoading(false);
          Utils.HandleException(err, true);
        });
    }
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      // console.log('target:', target);
      const clickedInsideSnooze = snoozeRef.current?.contains(target);
      const clickedInsideCalendar = (target as HTMLElement).closest('.react-datepicker') !== null || (target as HTMLElement).closest('.wp-ddl-snooze-calendar') !== null;
      if (!clickedInsideSnooze && !clickedInsideCalendar) {
        setIsSnoozeOpen(false);
      }
    };

    if (isSnoozeOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSnoozeOpen]);

  const applySnoozeDate = (isAdd: boolean) => {
    try {
      if (isAdd) {
        setSnoozeErr('');
        if (!snoozeDateTime) {
          setSnoozeErr('กรุณาระบุวันเวลาที่จะแจ้งเตือน');
          return;
        }
        // console.log([snoozeDateTime, snoozeDateTime.toISOString()]);
        // return;
        const now = new Date();
        const diffMs = snoozeDateTime.getTime() - now.getTime();
        const diffMinutes = diffMs / 1000 / 60;
        if (diffMinutes < 10) {
          setSnoozeErr('กรุณาตั้งเวลาอย่างน้อย 10 นาที');
          return;
        }
      }
      const api = new APIClient();
      setIsSnoozeLoading(true);
      const postId = activePostId ?? "";
      const parm = {
        postId: postId,
        snoozeDateTime: Utils.ToLocalDateString(snoozeDateTime),
        isSave: isAdd
      };
      // console.log('parm:', parm);
      api.fnPostForm(urls.WP_POST_SNOOZE_SAVE, parm)
        .then(rs => {
          console.log('rs:', rs);
          dispatch(setSnooze(postId, rs.snooze));
          setIsSnoozeLoading(false);
          setIsSnoozeOpen(false);
        })
        .catch(e2 => {
          setIsSnoozeLoading(false);
          setSnoozeErr(Utils.GetMessageFromExecption(e2));
        });
    } catch (e1) {
      setIsSnoozeLoading(false);
      setSnoozeErr(Utils.GetMessageFromExecption(e1));
    }
  }


  const addSnoozeDate = (increase: number, unit: "second" | "minute" | "hour" | "day") => {
    setSnoozeDateTime(Utils.DateAdd(new Date(), increase, unit));
  }

  const addSnoozeDate2 = (mode: "Today 1PM" | "Tomorrow 8AM" | "Tomorrow 1PM" | "Next Monday 8AM" | "1st Next Month") => {
    const now = new Date();
    let newDate = new Date();

    // Utility function to clone and set time
    const setTime = (baseDate: Date, hour: number, minute: number): Date => {
      const d = new Date(baseDate);
      d.setHours(hour, minute, 0, 0);
      return d;
    };

    switch (mode) {
      case "Today 1PM": {
        const todayAt1PM = setTime(now, 13, 0);
        // If it's already past 1PM today, move to tomorrow
        // if (todayAt1PM <= now) {
        //   todayAt1PM.setDate(todayAt1PM.getDate() + 1);
        // }
        newDate = todayAt1PM;
        break;
      }

      case "Tomorrow 8AM": {
        const tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);
        newDate = setTime(tomorrow, 8, 0);
        break;
      }

      case "Tomorrow 1PM": {
        const tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);
        newDate = setTime(tomorrow, 13, 0);
        break;
      }

      case "Next Monday 8AM": {
        const result = new Date(now);
        const day = result.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
        const daysUntilNextMonday = (8 - day) % 7 || 7; // Ensure it's at least 1 day ahead
        result.setDate(result.getDate() + daysUntilNextMonday);
        newDate = setTime(result, 8, 0);
        break;
      }

      case "1st Next Month": {
        const result = new Date(now);
        result.setMonth(result.getMonth() + 1);
        result.setDate(1);
        newDate = setTime(result, 8, 0); // Optional time, e.g., 8AM
        break;
      }

      default:
        throw new Error(`Unsupported mode: ${mode}`);
    }
    if (newDate > new Date()) {
      setSnoozeDateTime(newDate);
    }
  }
  const isPass1PM = new Date().getHours() >= 13;

  interface CustomInputProps {
    value?: string;
    onClick?: () => void;
  }

  const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
    ({ value, onClick }, ref) => (
      <input
        ref={ref}
        value={value}
        readOnly
        onClick={onClick}
        placeholder="Select date"
        style={{ cursor: "pointer", /*border:"solid 1px red"*/ }}
      />
    )
  );

  const onPreviewImage = (idImage: string) => {
    try {

      // console.log('onPreviewImage:', { activePostId, idImage });
      if (Utils.IsDesktop()) {
        const redirect = `/wpcol/${activePostIdRef.current}/${idImage}`;
        openUrlInSameTab(redirect);
      } else {
        setPreviewImage({ postIdParent: activePostIdRef.current, selImageId: idImage });
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const [previewImage, setPreviewImage] = useState<any>(null)

  return (
    <>
      {previewImage && <WorkplaceCollectionModal postIdParent={previewImage.postIdParent} selImageId={previewImage.selImageId} onToggle={() => setPreviewImage(null)}></WorkplaceCollectionModal>}

      <div id="workplace-container" className="workplace-container">
        {isSnoozeOpen && (
          <div className="wp-ddl-snooze" ref={snoozeRef}>
            <div className="d-flex justify-content-start align-items-center">
              <i className={classnames("hand material-icons fz-13 text-danger")}>snooze</i>ตั้งเตือนโพส
              {isSnoozeLoading && (<LoadingIconWithText loadingText={""} />)}
            </div>
            <div className="d-flex flex-wrap" style={{ gap: "3px" }}>
              {/* <span className="wp-tag-filter hand hover" onClick={() => addSnoozeDate(30, "minute")}>อีก 30 นาที</span>
            <span className="wp-tag-filter hand hover" onClick={() => addSnoozeDate(2, "hour")}>อีก 2 ชั่วโมง</span>
            <span className="wp-tag-filter hand hover" onClick={() => addSnoozeDate(1, "day")}>อีก 1 วัน</span>
            <span className="wp-tag-filter hand hover" onClick={() => addSnoozeDate(3, "day")}>อีก 3 วัน</span>
            <span className="wp-tag-filter hand hover" onClick={() => addSnoozeDate(7, "day")}>อีก 1 อาทิตย์</span> */}

              <span className={classnames("wp-tag-filter hand hover", { "disabled": isPass1PM })} onClick={() => addSnoozeDate2("Today 1PM")}>วันนี้ 1PM</span>
              <span className={classnames("wp-tag-filter hand hover")} onClick={() => addSnoozeDate2("Tomorrow 8AM")}>พรุ่งนี้ 8AM</span>
              <span className={classnames("wp-tag-filter hand hover")} onClick={() => addSnoozeDate2("Tomorrow 1PM")}>พรุ่งนี้ 1PM</span>
              <span className={classnames("wp-tag-filter hand hover")} onClick={() => addSnoozeDate2("Next Monday 8AM")}>จันทร์หน้า 8AM</span>
              <span className={classnames("wp-tag-filter hand hover")} onClick={() => addSnoozeDate2("1st Next Month")}>วันที่ 1 เดือนหน้า</span>

            </div>
            <DatePicker
              selected={snoozeDateTime}
              onChange={(date: any) => setSnoozeDateTime(date)}
              dateFormat={"dd/MM/yyyy HH:mm"} isClearable portalId="root-portal"
              className="form-control p-1"
              showTimeSelect={true}
              minDate={new Date()}
              popperPlacement="bottom-end"
              popperClassName="wp-ddl-snooze-calendar"
              customInput={<CustomInput />}
              calendarStartDay={1}
            ></DatePicker>
            <div className="d-flex justify-content-end align-items-center" style={{ gap: "5px" }}>
              <button className="flex-fill fz-09 btn btn-sm btn-danger" onClick={(e) => applySnoozeDate(false)}>ลบ</button>
              <button className="flex-fill fz-09 btn btn-sm btn-warning" onClick={(e) => setIsSnoozeOpen(false)}>ยกเลิก</button>
              <button className="flex-fill fz-09 btn btn-sm btn-primary" onClick={(e) => applySnoozeDate(true)}>ตกลง</button>
            </div>
            {snoozeErr && (<div className="d-flex justify-content-end align-items-center text-danger" style={{ overflow: "auto" }}>{snoozeErr}</div>)}
          </div>
        )}

        {/* header */}
        <div className="p-3 p-md-2 workplace-header">
          <WorkplaceHead onOpenPostDetails={() => { }} onTagClick={onTagClick} onSnoozeClick={onSnoozeClick} />
        </div>

        {/* emoji resp */}
        {isEmojiRespShow && (
          <div ref={popupRef} className="workplae-post-tool" style={{ left: emojiRespPos.left, top: emojiRespPos.top }}>
            {/* emoji plate */}
            <div className="row">
              {emojis.map((emoji, index) => (
                <React.Fragment key={index}>
                  <div
                    // key={index}
                    className="col text-center workplae-emoji-tool-each hover"
                    onClick={() => onClickRespEmoji(emoji)}
                    style={{ cursor: 'pointer', fontSize: '1.5rem'/*, margin: '5px 0', width: "30px", height: "30px"*/ }}
                    title={emoji.name}
                  >
                    {emoji.icon}
                  </div>
                  {(index + 1) % 4 == 0 && (<div className="w-100"></div>)}
                </React.Fragment>
              ))}
            </div>
            <div className="row">
              <div className="col">
                <hr className="w-100" style={{ marginTop: "5px", marginBottom: "5px" }} />
              </div>
            </div>
            <div id="mnuUnsendPost" className="row">
              {unSendPostProcessing && (<div className="col" style={{ fontSize: "1.0rem" }}><LoadingIconWithText loadingText={"กำลังยกเลิก"} /></div>)}
              {!unSendPostProcessing && (
                <div className="col hover hand" style={{ fontSize: "1.0rem" }} onClick={() => onUnSendPost()}>
                  <i className="fa fa-undo"></i>&nbsp;ยกเลิกข้อความ
                </div>
              )}
            </div>
          </div>
        )}

        {/* content */}
        {converLoading && (<Loader />)}
        <AppSimpleBar className="workplace-chat" scrollRef={refScroll} onScrollCapture={handleScroll} style={{ height: `calc(100vh - ${heightHeader}px - ${heightBottom}px)` }}>
          {/* <div className="p-3 p-md-2 ">
          <ul className="list-unstyled">
            {convers.map((conv: WpConver, key: number) => (
              <li
                key={key}
                post-id={conv.postId}
                className={classnames(
                  "chat-list",
                  { right: false },
                  { reply: false },
                  { "read-no-dark": !conv.isRead && isDark },
                  { "read-no-light": !conv.isRead && !isDark },
                )}
                is-from-me={conv.isFromMe ? 1 : 0}
                is-read={conv.isRead ? 1 : 0}
                ref={key === convers.length - 1 ? lastMessageRef : null}
              >
                <div className="wp-conver mb-3"  >
                  <ContentV2 conv={conv} />
                </div>
              </li>
            ))}
          </ul> 
        </div> */}
          {/* use div seem better performance than UL */}
          <div id="divConverContainer" className="p-3 p-md-2" style={{ display: "flex", flexDirection: "column" }}>
            {convers.map((conv: WpConver, key: number) => (
              // <div key={key} className="wp-conver mb-3" ref={key === convers.length - 1 ? lastMessageRef : null} >
              <div key={key} className="wp-conver mb-3">
                {conv.isUnsend ? (
                  <ContentUnsend conv={conv} index={key} />
                ) : conv.postType == WpPostType.ChangeStatus ? (
                  <ContentChangeStatus conv={conv} index={key} />
                ) : (
                  <ContentV2 conv={conv} index={key} />
                )}
                {/* <ContentV2 conv={conv} index={key} /> */}
              </div>
            ))}
          </div>
        </AppSimpleBar>
        {haveNewText && (
          <span id="spnNewText" className='span-new-post-text hand text-red' onClick={onGoBottom} >
            <i className="fas fa-angle-down"></i>&nbsp;ข้อความใหม่จาก {haveNewText}&nbsp;<i className="fas fa-angle-down"></i>
          </span>
        )}
        <i id="back-button-wp" className='back-button-wp bx bx-down-arrow-circle hand' onClick={onGoBottom} ></i>

        {/* input */}

        {(activePostStatus === WpStatus.Open && activePostYouIsMember) && (
          <div className="p-3 p-md-2 workplace-input" style={{ height: inputPanelHeight }}>
            <WorkplaceQuill
              editorMinHeight={inputEditorHeight}
              editorMaxHeight={inputEditorHeight}
              isLargeStage={isLageEditor}
              onLargeStageClick={onLargeStageClick}
            // onSave={onSave}
            // onSaving={onSaving}
            />
            {/* <WorkplaceInput /> */}
          </div>
        )}

        {/* {activePostStatus !== WpStatus.Open && (
        <div className="p-3 p-md-2 workplace-input" style={{ height: "40px" }}>

        </div>
      )} */}

      </div>
    </>
  );
};

export default WorkplaceContent;
